import { render, staticRenderFns } from "./editEstate.vue?vue&type=template&id=ca86d1ce&scoped=true"
import script from "./editEstate.vue?vue&type=script&lang=js"
export * from "./editEstate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca86d1ce",
  null
  
)

export default component.exports